/* eslint-disable local/no-raw-colors */
import React from 'react'
import type { SvgProps } from 'react-native-svg'
import { ClipPath, Defs, G, Path, Rect, Svg } from 'react-native-svg'

export const ThunderYellow: React.FC<SvgProps> = props => (
    <Svg viewBox='0 0 32 32' {...props}>
        <G clipPath='url(#clip0_11153_125891)'>
            <Path
                d='M32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32C24.8366 32 32 24.8366 32 16Z'
                fill='#606063'
            />
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M19.9163 12.6852C19.9586 12.7338 19.9864 12.795 19.9961 12.8608C20.0059 12.9267 19.9971 12.9941 19.9709 13.0545L15.7507 22.7883C15.7101 22.8704 15.6442 22.9346 15.5643 22.97C15.4844 23.0053 15.3956 23.0096 15.3131 22.982C15.1416 22.9217 15.04 22.7461 15.0785 22.569L16.619 15.7717L13.4456 16.622C13.4141 16.6295 13.3826 16.6295 13.3518 16.6295C13.2636 16.6299 13.178 16.5974 13.1095 16.5375C13.0661 16.4983 13.0337 16.4469 13.0157 16.3891C12.9978 16.3312 12.9951 16.2691 13.008 16.2097L14.5793 9.26923C14.6008 9.18985 14.6461 9.12038 14.7082 9.07169C14.7703 9.023 14.8456 8.99784 14.9224 9.00015H17.4866C17.6826 9.00015 17.8381 9.15994 17.8381 9.3544C17.836 9.40723 17.8225 9.45883 17.7989 9.50515L16.4629 13.3997L19.5578 12.5751C19.5881 12.5656 19.6194 12.56 19.6509 12.5586C19.7524 12.5586 19.8463 12.6098 19.9163 12.6852Z'
                fill='#F8D41D'
            />
        </G>
        <Defs>
            <ClipPath id='clip0_11153_125891'>
                <Rect fill='white' />
            </ClipPath>
        </Defs>
    </Svg>
)
